import { observer } from 'mobx-react';
import {
  PROFILER_SEARCH_CATEGORY_FIELDS,
  PROFILER_SEARCH_FIELDS
} from '../../../../utils/constants/fields';
import Radio from '../../../../components/inputs/Radio';
import { PROFILER_SEARCH_CATEGORIES } from '../../../../utils/constants/searchCategories';
import { useStore } from '../../../../store/store';
import IconButton, { ICON_BUTTON_ICONS } from '../../../../components/buttons/IconButton';
import {
  isProfilerAdvancedCriteriaDisabled,
  isProfilerAdvancedCriteriaSituationDisabled,
  isProfilerAdvancedCriteriaOwnershipDisabled
} from '../../../../utils/constants/variables';

const ProfilerCompanyCriteriaSearchFormDesktop = observer(
  ({
    fields,
    isSearchDisabled,
    onSearch,
    tabs,
    categoryFields,
    setCategoryFieldValue,
    categoryOptions,
    isAdvancedFieldsToggled,
    toggleAdvancedFields
  }) => {
    const { utilsStore, profilerAccessStore } = useStore();
    if (utilsStore.windowWidth < 1201) {
      return null;
    }

    return (
      <div className="formform desktop">
        <div className="fields-area">
          {tabs}
          <div className="row category-group">
            <Radio
              field={PROFILER_SEARCH_CATEGORY_FIELDS.SEARCH_CATEGORY}
              value={categoryFields[PROFILER_SEARCH_CATEGORY_FIELDS.SEARCH_CATEGORY.NAME]}
              setFieldValue={setCategoryFieldValue}
              values={categoryOptions}
              disabled={!profilerAccessStore.canUseProfilerSearch}
            />
          </div>
          <div className="flip-horizontal-fields-area">
            {profilerAccessStore.isProfilerDemo && (
              <div
                className={`profiler-demo-info-message${
                  profilerAccessStore.demoSearchExceededLimit ? ' exceeded' : ''
                }`}>
                <div className="img-wrap">
                  <img src={ICON_BUTTON_ICONS.EXCLAMATAION_CIRCLE} />
                </div>
                <div className="text">
                  {profilerAccessStore.demoSearchExceededLimit ? (
                    <>
                      You&apos;ve used all {profilerAccessStore.demoSearchMaxCount} demo searches -
                      upgrade to full access to continue exploring.
                    </>
                  ) : (
                    <>
                      You have {profilerAccessStore.demoSearchRemainingCount} out of{' '}
                      {profilerAccessStore.demoSearchMaxCount} demo searches remaining - upgrade to
                      full access to unlock unlimited searches.
                    </>
                  )}
                </div>
              </div>
            )}

            <div className="row">
              {fields[PROFILER_SEARCH_FIELDS.INDUSTRY.ID]}
              {fields[PROFILER_SEARCH_FIELDS.VALUE_CHAIN.ID]}
              {fields[PROFILER_SEARCH_FIELDS.PRODUCT_PORTFOLIO.ID]}
            </div>
            <div className="row">
              {
                fields[
                  PROFILER_SEARCH_FIELDS.REVENUE_MIN.ID + PROFILER_SEARCH_FIELDS.REVENUE_MAX.ID
                ]
              }
              <div className="col"></div>
              {!isAdvancedFieldsToggled ? (
                <div className="col search-btn-wrap">
                  <button
                    className="btn btn-primary disable-fade-primary"
                    disabled={isSearchDisabled}
                    onClick={onSearch}>
                    Search
                  </button>
                </div>
              ) : (
                <div className="col"></div>
              )}
            </div>
            {isAdvancedFieldsToggled &&
              (isProfilerAdvancedCriteriaDisabled ? (
                <>
                  <div className="row">
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.EMPLOYEES_MIN.ID +
                          PROFILER_SEARCH_FIELDS.EMPLOYEES_MAX.ID
                      ]
                    }
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.HEADQUARTER.ID
                      ]
                    }
                    <div className="col" />
                  </div>
                </>
              ) : (
                <>
                  <div className="row">
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.CAGR_MIN.ID + PROFILER_SEARCH_FIELDS.CAGR_MAX.ID
                      ]
                    }
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.CAGR_PERIOD.ID
                      ]
                    }
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.EBIT_MARGIN_MIN.ID +
                          PROFILER_SEARCH_FIELDS.EBIT_MARGIN_MAX.ID
                      ]
                    }
                  </div>
                  <div className="row">
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.EMPLOYEES_MIN.ID +
                          PROFILER_SEARCH_FIELDS.EMPLOYEES_MAX.ID
                      ]
                    }
                    {!isProfilerAdvancedCriteriaSituationDisabled && (
                      <>
                        {
                          fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                            PROFILER_SEARCH_FIELDS.SITUATION.ID
                          ]
                        }
                      </>
                    )}
                    {isProfilerAdvancedCriteriaSituationDisabled && <div className="col" />}
                    <div className="col" />
                  </div>
                  {!isProfilerAdvancedCriteriaOwnershipDisabled && (
                    <div className="row">
                      {
                        fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                          PROFILER_SEARCH_FIELDS.LISTING_STATUS.ID
                        ]
                      }
                      {
                        fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                          PROFILER_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.ID
                        ]
                      }
                      {
                        fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                          PROFILER_SEARCH_FIELDS.OWNERSHIP_BASIS.ID
                        ]
                      }
                    </div>
                  )}
                  {/* Third row: Geo location fields - Country, City/Zipcode, Distance */}
                  <div className="row">
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.HEADQUARTER.ID
                      ]
                    }
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.CITY_ZIPCODE.ID
                      ]
                    }
                    {
                      fields[PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA][
                        PROFILER_SEARCH_FIELDS.DISTANCE.ID
                      ]
                    }
                  </div>
                </>
              ))}
            {isAdvancedFieldsToggled ? (
              <div className="row">
                <div className="col advanced-criteria-btn-wrap toggled">
                  <IconButton
                    innerText="Main search criteria"
                    icon={ICON_BUTTON_ICONS.CHEVRON_UP}
                    iconOnRight
                    onClick={toggleAdvancedFields}
                    withFill={false}
                    withBorder={false}
                  />
                </div>
                <div className="col"></div>
                <div className="col search-btn-wrap">
                  <button
                    className="btn btn-primary disable-fade-primary"
                    disabled={isSearchDisabled}
                    onClick={onSearch}>
                    Search
                  </button>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col advanced-criteria-btn-wrap">
                  <IconButton
                    innerText="Advanced search criteria"
                    icon={ICON_BUTTON_ICONS.CHEVRON_DOWN}
                    iconOnRight
                    onClick={toggleAdvancedFields}
                    withFill={false}
                    withBorder={false}
                  />
                </div>
                <div className="col"></div>
                <div className="col"></div>
              </div>
            )}

            <div
              className="fields-area-mandatory-row"
              style={{ marginTop: isAdvancedFieldsToggled ? '32px' : '94px' }}>
              <font className="red-asterisk">*</font>mandatory fields
            </div>
            <div className="company-criteria-search-form-extra-info">
              <div className="icon-wrap-info">
                <img src={ICON_BUTTON_ICONS.INFO_CIRCLE} />
              </div>
              <div className="text-info">
                Use commas to separate keywords. Search combines all terms (AND logic) to show
                relevant results.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default ProfilerCompanyCriteriaSearchFormDesktop;
